import { reactive } from "vue";
import { useFilters } from "@/composables/filters/useFilters";
import { getDefaultFiltersForKey } from "@components/constants/filterDefaultsRegistry";

let instance = null;

export function useViewState() {
  if (instance) return instance;
  const filter = useFilters();
  const state = reactive({
    filters: {
      values: getDefaultFiltersForKey("readinessResponsibilities"),
      searchText: "",
      showFilterDialog: false,
      key: "readinessResponsibilities",
      clearSelection: "",
      needsRecalculation: false,
    },
    loading: {
      table: false,
    },
    table: {
      currentPage: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      search: "",
    },
    showCurrentBageHolderList: false,
    selectedResponsibility: null,
    selectedBadgeOption: "",
  });

  const applyFilters = (filters) => {
    const newArray = filters
      .map((item) => {
        if (item.value !== null) {
          if (typeof item === "string") {
            return item;
          } else if (
            typeof item === "object" &&
            // eslint-disable-next-line no-prototype-builtins
            item.hasOwnProperty("value")
          ) {
            return item.value;
          }
        }
      })
      .filter(Boolean);
    filter.setFilters({ key: state.filters.key, filters: newArray });
    state.filters.values = newArray;
    state.filters.showFilterDialog = false;
  };

  const removeFilters = (removedFilters) => {
    filter.setFilters({
      key: state.filters.key,
      filters: state.filters.values,
    });
    state.filters.clearSelection = removedFilters;
  };

  const getOrgObjectCardProps = (obj) => {
    return {
      code: obj.code,
      name: obj.name,
      showIcon: false,
      removeUnderlineToName: true,
      id: obj.id,
      hideHover: true,
    };
  };
  const getBadgesCounterLevelProps = (obj) => {
    return {
      apprenticeCountBadges: obj.checkpoint.apprentice,
      professionalCountBadges: obj.checkpoint.professional,
      coachCountBadges: obj.checkpoint.coach,
      masterCountBadges: obj.checkpoint.master,
      id: obj.id,
    };
  };
  const getCoachAvatarPeopleProps = (obj) => {
    return {
      avatars: obj.coach_badges,
      maxVisible: 3,
      isShowTooltip: true,
      size: "medium",
    };
  };
  const getMasterAvatarPeopleProps = (obj) => {
    return {
      avatars: obj.master_badges,
      maxVisible: 3,
      isShowTooltip: true,
      size: "medium",
    };
  };
  const onClickCoachPeopleAvatar = (item) => {
    state.showCurrentBageHolderList = true;
    state.selectedResponsibility = item;
    state.selectedBadgeOption = "coach_badges";
  };
  const onClickMasterPeopleAvatar = (item) => {
    state.showCurrentBageHolderList = true;
    state.selectedResponsibility = item;
    state.selectedBadgeOption = "master_badges";
  };
  const onClickBadgesCounterLevel = (item) => {
    state.showCurrentBageHolderList = true;
    state.selectedResponsibility = item;
    state.selectedBadgeOption = "";
  };

  // Métodos para filtros
  const updateFilter = (filterName, value) => {
    if (filterName in state.filters) {
      state.filters[filterName] = value;
    }
  };

  const clearFilters = () => {
    // ER-11195: "Clear all" restores the documented defaults from the central
    // registry instead of resetting the whole filters object to a legacy shape.
    state.filters.values = filter.resetToDefaults(state.filters.key);
    state.filters.showFilterDialog = false;
  };

  // Métodos para loading
  const setLoading = (key, value) => {
    if (key in state.loading) {
      state.loading[key] = value;
    }
  };

  instance = {
    state,
    updateFilter,
    clearFilters,
    setLoading,
    getOrgObjectCardProps,
    getBadgesCounterLevelProps,
    applyFilters,
    removeFilters,
    getCoachAvatarPeopleProps,
    getMasterAvatarPeopleProps,
    onClickCoachPeopleAvatar,
    onClickMasterPeopleAvatar,
    onClickBadgesCounterLevel,
  };
  return instance;
}

export function resetResponsibilityDirectoryViewState() {
  instance = null;
}
